import { HighlightIconText } from '@/components/HighlightMediaText/HighlightMediaText';
import Icon from '@/components/Icon/Icon';
import { ButtonContent } from '@/components/OldButton/OldButton';
import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/sunrunTheme.styles';

import useStyles from './FeatureItems.styles';

export type TextContentProps = {
  subhead?: string;
  features?: HighlightIconText[];
  cta?: ButtonContent[];
  isHeroMode?: boolean;
  eyebrow?: string;
  headline?: string;
  isOnDark: boolean;
};

const FeatureItems = ({
  features,
  isOnDark,
  ...props
}: TextContentProps): React.JSX.Element => {
  const { classes: globalClasses } = useGlobalStyles({ fixed: false });
  const { classes, cx } = useStyles();

  return (
    <div className={classes.features} {...props}>
      {features &&
        features.map((feature, index) => {
          const { name, icon, text } = feature?.fields ?? {};
          return (
            <div
              key={'highlight-image-text-feature-' + index + name}
              className={cx(
                isOnDark
                  ? `${classes.featureContainer} darkMode`
                  : classes.featureContainer
              )}
            >
              {icon && (
                <div className={classes.featureIcon}>
                  <Icon
                    name={icon.fields.name || ''}
                    color={isOnDark ? brandColors.white : brandColors.black}
                  />
                </div>
              )}
              {text && <div className={cx(globalClasses.h5)}>{text}</div>}
            </div>
          );
        })}
    </div>
  );
};

export default FeatureItems;
